@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.InfoContainer {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  display: grid;
  gap: 0.3em 0.5em;
  color: $theme-color-text;
  margin: 0;
  align-items: baseline;
  border: 1px solid $theme-color-borders;
  border-radius: 6px;
  padding: 1rem;
}
